export const REPORT_TYPE_DEAL_PIPELINE_SUMMARY: string = 'deal-pipeline-summary';
export const REPORT_TYPE_DEAL_BUILD_TO_SUIT_PIPELINE_SUMMARY: string = 'deal-build-to-suit-pipeline-summary';
export const REPORT_TYPE_DEAL_POWER_BI_DATASET: string = 'deal-power-bi-dataset';
export const REPORT_TYPE_ACTIVITY_CAPITAL_RAISE_DEBT: string = 'activity-capital-raise-debt';
export const REPORT_TYPE_ACTIVITY_CAPITAL_RAISE_FUND: string = 'activity-capital-raise-fund';
export const REPORT_TYPE_ASSET_PORTFOLIO: string = 'asset-portfolio';
export const REPORT_TYPE_ASSET_LOAN_TAPE: string = 'asset-loan-tape';
export const REPORT_TYPE_DEAL_TASK_DUE_DILIGENCE_STATUS: string = 'deal-task-due-diligence-status';
